/* eslint-disable consistent-return */
import store from "@/store";
import { getInstance } from "./index";

export default (to, from, next) => {
  const authService = getInstance();

  const guardAction = async () => {
    // reauthenticate if feathers client is not authenticated
    if (!store.getters["auth/isAuthenticated"]) {
      try {
        await store.dispatch("auth/reauthenticate");
      } catch (error) {
        console.error("Error re-authenticating", error);
      }
    }

    // check if user is authenticated with any method
    if (!store.getters["auth/isAuthenticated"] && !authService.isAuthenticated) {
      return next({ name: "Login" });
    }

    // Verify if user has license
    let user;
    if (store.getters["auth/isAuthenticated"]) {
      // user is authenticated with feathers
      user = store.getters["auth/user"];
    }
    if (!user && authService.isAuthenticated) {
      // user is authenticated with auth0
      const query = { id: authService.user.id };
      user = await store.dispatch("users/find", { query })?.data?.[0];
    }

    if (!user) {
      return next({ name: "Login" });
    }

    const licenseTypes = user.licenses.map((l) => l.type.trim().toUpperCase());
    if (!licenseTypes.includes(`ANALYTICS_USER_V4`)) {
      const error = new Error("No Analytics license found");
      error.name = "Forbidden";
      next(error);
    }

    return next();
  };

  if (authService.loading === false) {
    return guardAction();
  }

  authService.$watch("loading", (loading) => {
    if (loading === false) {
      return guardAction();
    }
  });
};
